// extracted by mini-css-extract-plugin
export var apy = "index-module--apy--8a0da";
export var bottom = "index-module--bottom--14f0f";
export var bottomComing = "index-module--bottomComing--a8c3d";
export var bottomContent = "index-module--bottomContent--b5211";
export var bottomNumber = "index-module--bottomNumber--63656";
export var bottomTitle = "index-module--bottomTitle--231bd";
export var coin = "index-module--coin--5ec57";
export var content = "index-module--content--99b38";
export var governance = "index-module--governance--146b2";
export var hr = "index-module--hr--c4254";
export var item = "index-module--item--28442";
export var label = "index-module--label--ae4aa";
export var numbers = "index-module--numbers--89a7a";
export var placeHolderDiv = "index-module--placeHolderDiv--9c4c3";
export var rightContent = "index-module--rightContent--1d042";
export var title = "index-module--title--b2f96";
export var top = "index-module--top--7aeba";
export var topNumber = "index-module--topNumber--d86cd";